module.exports = __webpack_public_path__ + "img/talron-menu-contact.afa05705.svg";